import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Button, Modal, Badge, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Link } from "react-router-dom";
import $ from "jquery";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Select from "react-select";

const Packing_Checklist_Cat = ({ show, onClose, order }) => {

  const [Checked, checkIsChecked] = useState(false);
  const BaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [addOnService, setAddOnService] = useState([]);

  const tableRef = useRef(null);
  useEffect(() => {
    if (tableRef.current) {
      if (!$.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable({
          "responsive": true,
          //   "aaSorting": [],
          "ordering": false,
          "paging": false,
          "language": {
            "lengthMenu": "Show _MENU_",
          },
          "dom":
            "<'row'" +
            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
            // "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
            ">" +
            "<'table-responsive'tr>" +
            "<'row'" +
            // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
            ">"
        });
      }
    }
  }, []);

  const styles = {
    tableContainer: {
      maxHeight: "300px", // scroll height
      overflowY: "auto",
    },
    stickyHeader: {
      position: "sticky",
      top: 0,
      background: "#012E1D",
      zIndex: 10,
    },
  };

  const items = useMemo(() => order?.item_list ?? [], [order]);
  const addonServices = useMemo(() => order?.addons_list ?? [], [order]);


  const [rows, setRows] = useState([]);
  const [addonRows, setAddonRows] = useState([]);
  const [cookwares, setCookwares] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  // Track only manually checked IDs
  const [checkedItemIds, setCheckedItemIds] = useState([]);
  const [checkedAddonIds, setCheckedAddonIds] = useState([]);

  /** Fetch cookwares */
  useEffect(() => {
    if (!BaseUrl) return;
    axios
      .get(`${BaseUrl}/cookwares/get_active`)
      .then((res) =>
        setCookwares(Array.isArray(res.data) ? res.data : res.data?.data ?? [])
      )
      .catch(() => toast.error("Failed to load vessels"));
  }, [BaseUrl]);

  const cookwareOptions = cookwares.map(c => ({
    value: c.sno,
    label: `${c.cookware_name} (Available: ${c.cookware_count})`
  }));

  const getMeasurementUnit = (value) => {
    const units = {
      1: "kgs",
      2: "kgs",
      3: "ltrs",
      4: "ltrs",
      5: "no's",
    };
    return units[value] || "";
  };

  /** Initialize item rows */
  useEffect(() => {
    if (!order || !items) return;
    const backendItems = order.items ?? [];
    const vesselMap = order.vessels_list ?? [];

    const formatted = items.map((item) => {
      const backendItem = backendItems.find((b) => b.id === item.id);
      const vesselData = vesselMap.find((v) => v.id === item.id);

      return {
        id: item.id,
        name: item.item_name,
        total: item.quantity ?? 0,
        measurement_quantity: getMeasurementUnit(item.measurement_quantity),
        disabled: backendItem?.status === 2,
        vessels:
          vesselData?.vessels?.map((v) => ({ vessel_sno: v.id, vessel_count: v.count })) ?? [],
        currentVessel: "",
        currentCount: "",
      };
    });

    setRows(formatted);
    setCheckedItemIds(
      formatted.filter((r) => backendItems.find((b) => b.id === r.id)).map((r) => r.id)
    );
  }, [order, items]);

  /** Initialize addon rows */
  useEffect(() => {
    if (!order || !addonServices) return;
    const backendAddons = order.addons ?? [];

    const formatted = addonServices.map((addon) => {
      const backendAddon = backendAddons.find((b) => b.id === addon.id);

      return {
        id: addon.id,
        name: addon.service_name,
        total: addon.quantity ?? 0,
        disabled: backendAddon?.status === 2,
      };
    });

    setAddonRows(formatted);
    setCheckedAddonIds(
      formatted.filter((r) => backendAddons.find((b) => b.id === r.id)).map((r) => r.id)
    );
  }, [order, addonServices]);

  /** Handle individual checkbox */
  const handleCheckboxChange = (id, checked) => {
    setCheckedItemIds((prev) =>
      checked ? [...prev, id] : prev.filter((x) => x !== id)
    );
  };

  const handleAddonCheckboxChange = (id, checked) => {
    setCheckedAddonIds((prev) =>
      checked ? [...prev, id] : prev.filter((x) => x !== id)
    );
  };


  /** Handle select all */
  const allSelected = rows.filter((r) => !r.disabled).length > 0 &&
    rows.filter((r) => !r.disabled).every((r) => checkedItemIds.includes(r.id));

  const handleSelectAll = (checked) => {
    if (checked) {
      const allIds = rows.filter((r) => !r.disabled).map((r) => r.id);
      setCheckedItemIds(allIds);
    } else {
      setCheckedItemIds([]);
    }
  };

  const addonSelectAll = addonRows.filter((r) => !r.disabled).length > 0 &&
    addonRows.filter((r) => !r.disabled).every((r) => checkedAddonIds.includes(r.id));

  const handleAddonSelectAll = (checked) => {
    if (checked) {
      const allIds = addonRows.filter((r) => !r.disabled).map((r) => r.id);
      setCheckedAddonIds(allIds);
    } else {
      setCheckedAddonIds([]);
    }
  };

  /** Vessel management */
  const handleTempVesselChange = (itemId, field, value) => {
    setRows((prev) =>
      prev.map((row) => (row.id === itemId ? { ...row, [field]: value } : row))
    );
  };

  const handleAddVessel = (rowId) => {
    setRows((prev) =>
      prev.map((row) => {
        if (row.id === rowId && row.currentVessel && row.currentCount !== "") {
          const vesselSno = Number(row.currentVessel);
          const vesselCount = Number(row.currentCount);

          const existingIndex = row.vessels.findIndex((v) => Number(v.vessel_sno) === vesselSno);
          const updated = [...row.vessels];
          if (existingIndex !== -1) updated[existingIndex].vessel_count = vesselCount;
          else updated.push({ vessel_sno: vesselSno, vessel_count: vesselCount });

          return { ...row, vessels: updated, currentVessel: "", currentCount: "" };
        }
        return row;
      })
    );
  };


  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const handleSubmit = async () => {
    if (!order?.sno) return toast.error("Order identifier not found.");
    if (submitting) return;
    setSubmitting(true);

    try {
      // Only send checked items/addons
      const itemsData = rows
        .filter((r) => checkedItemIds.includes(r.id))
        .map((row) => ({
          id: row.id,
          packing_quantity: row.vessels.reduce((acc, v) => acc + Number(v.vessel_count), 0),
          status: 2,
        }));

      const vessels_list = rows
        .filter((r) => r.vessels.length && checkedItemIds.includes(r.id))
        .map((row) => ({
          id: row.id,
          vessels: row.vessels.map((v) => ({ id: Number(v.vessel_sno), count: Number(v.vessel_count) })),
        }));

      const addonsData = addonRows
        .filter((a) => checkedAddonIds.includes(a.id))
        .map((a) => ({ id: a.id, status: 2 }));

      const payload = { branch: branch_id, items: itemsData, vessels_list, addons: addonsData };

      const res = await axios.post(`${BaseUrl}/corp-packing-item-update/${order.sno}`, payload);

      if (res?.data?.status) {
        toast.success("Packing checklist submitted!");
        onClose();
      } else toast.error(res?.data?.message ?? "Submit failed");
    } catch (err) {
      toast.error(err?.response?.data?.message ?? "Error submitting");
    } finally {
      setSubmitting(false);
    }
  };

  // format date display
  const formatDateDisp = (date) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = months[d.getMonth()];
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Modal show={show} onHide={onClose} size="xl">
      <div className="modal-content border border-red rounded-xxl">
        {/* header */}
        <div className="modal-header" style={{ backgroundColor: "#3ab384" }}>
          <h3 className="modal-title text-white">Packing Checklist</h3>
          <Button
            variant=""
            type="button"
            className="close px-6 py-2"
            data-dismiss="modal"
            onClick={onClose}
          >
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          {/* Packing Details */}
          <div className="row mb-1">

            <div className="col-lg-2">
              <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip>Customer Name</Tooltip>}>
                <label className="text-danger fw-bold fs-5">{order?.customer_name ?? "-"}</label>
              </OverlayTrigger>
              <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip>Customer Number</Tooltip>}>
                <label className="fs-7 text-black d-block">{order?.customer_number}</label>
              </OverlayTrigger>
            </div>

            <div className="col-lg-4">
              <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip>Corporate Order ID</Tooltip>}>
                <label className="text-danger fw-bold fs-5">{order?.order_id}</label>
              </OverlayTrigger>
              <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip>Order Delivery Date</Tooltip>}>
                <label className="fs-7 text-black d-block">{formatDateDisp(order?.packing_date)}</label>
              </OverlayTrigger>
            </div>

            <div className='col-lg-3'>
              <div className='d-flex flex-column align-items-center justify-content-center'>
                <label className='text-black font-w500 fs-5'>Total Items</label>
                <label className="fs-5 text-danger font-w500 border border-danger py-1 px-2 rounded">{order?.total_packing_count}</label>
              </div>
            </div>

            <div className='col-lg-3'>
              <div className='d-flex flex-column align-items-center justify-content-center'>
                <label className='text-black font-w500 fs-5'>Total Add-On's</label>
                <label className="fs-5 text-danger font-w500 border border-danger py-1 px-2 rounded">{order?.addons_count}</label>
              </div>
            </div>

          </div>

          {/* Items */}
          <h5 className="text-black font-w600 mb-3 fs-4">Items Checklist</h5>
          <div style={styles.tableContainer} className="mb-3">
            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
              <thead>
                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                  <th className='min-w-20px'><input type="checkbox" checked={allSelected} onChange={(e) => handleSelectAll(e.target.checked)} /></th>
                  <th className='min-w-100px'>Item</th>
                  <th className='min-w-50px'>Total Qty</th>
                  <th className='min-w-100px'>Vessel & Count</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td className="align-content-center">
                      <input
                        type="checkbox"
                        checked={checkedItemIds.includes(row.id)}
                        disabled={row.disabled}
                        onChange={(e) => handleCheckboxChange(row.id, e.target.checked)}
                      />
                    </td>
                    <td className="text-black fs-6 align-content-center">{row.name}</td>
                    <td className="text-black fs-7 align-content-center">{row.total} {row.measurement_quantity}</td>
                    <td className="d-flex gap-2 align-content-center">

                      <Select
                        className="min-w-350px"
                        placeholder="Select Vessel"
                        value={cookwareOptions.find(o => o.value === row.currentVessel) || null}
                        onChange={(selectedOption) =>
                          handleTempVesselChange(row.id, "currentVessel", selectedOption?.value || "")
                        }
                        options={cookwareOptions}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      />

                      <div className="min-w-5px max-w-10px">
                        <input type="number" className="form-control " placeholder="Count" value={row.currentCount} onChange={(e) => handleTempVesselChange(row.id, "currentCount", e.target.value)} />
                      </div>

                      <div className="min-w-5px max-w-10px align-content-center">
                        <button className="btn btn-sm btn-success" onClick={() => handleAddVessel(row.id)}>Add</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Selected Vessels */}
          {rows.some(row => row.vessels.length > 0) && (
            <h5 className="text-black font-w600 mb-3 fs-4">Selected Vessels</h5>
          )}

          {rows.some(row => row.vessels.length > 0) && (
            <div className="p-4 rounded" style={{ backgroundColor: '#f0f5ef', maxHeight: '200px', overflowY: 'auto', }}>
              {rows.map(row => row.vessels.length > 0 && (

                <div key={row.id} className="mb-2">
                  <h5 className="text-black font-w600 mb-3 fs-4">{row.name} - Selected Vessels</h5>
                  <div className="d-flex flex-wrap gap-2" style={{ rowGap: "15px" }}>
                    {row.vessels.map((v, idx) => {
                      const vessel = cookwares.find(c => Number(c.sno) === Number(v.vessel_sno));
                      return (
                        <div key={idx} className="p-3 rounded shadow-sm bg-white" style={{ width: "calc(20% - 10px)", border: "1px solid #e0e0e0", }}>
                          <div className="fw-bold text-black fs-6">
                            {vessel?.cookware_name ?? "-"}
                          </div>

                          <div className="fs-6 text-black mt-1">
                            {v.vessel_count} No's
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Addons */}
          {addonRows.length > 0 && (
            <>
              <h5 className="text-black font-w600 mb-3 fs-4">Add-On's Checklist</h5>
              <div style={styles.tableContainer} className="mb-3">
                <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                  <thead>
                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                      <th className='min-w-20px'><input type="checkbox" checked={addonSelectAll} onChange={(e) => handleAddonSelectAll(e.target.checked)} /></th>
                      <th className='min-w-100px'>Add-On</th>
                      <th className='min-w-80px'>Total Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addonRows.map(row => (
                      <tr key={row.id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={checkedAddonIds.includes(row.id)}
                            disabled={row.disabled}
                            onChange={(e) => handleAddonCheckboxChange(row.id, e.target.checked)}
                          />
                        </td>
                        <td className="text-black">{row.name}</td>
                        <td className="text-black">{row.total} No's</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
            <button className="btn btn-sm btn-primary" onClick={handleSubmit}>
              Submit Packing Checklist
              <i className="fas fa-angle-double-right ms-2"></i>
            </button>
          </div>
        </div>

      </div>
    </Modal>
  );
}

export default Packing_Checklist_Cat;